import { Label, LabelProps } from '@a-ui/react';
import dayjs from 'dayjs';
import React from 'react';
import { translate } from '../../i18n';
import { ITranslations } from '../../i18n/config';
import LayoutTile from '../LayoutTile';
import Typography from '../Typography';
import useConfig from '../../hooks/config.hooks';

const STATUS_COLORS: Record<string, string[]> = {
  warning: ['actionrequired', 'doing', 'draft', 'pendingpayment', 'todo'],
  danger: ['cancelled', 'cancelledpaymentfailed', 'declined'],
};

interface TicketProps {
  data: Api.Ticket;
}

const Ticket: React.FC<TicketProps> = ({ data }) => {
  const { SPORT_DEFINITION_ID } = useConfig();

  const isSportReservation = data.definition.id === SPORT_DEFINITION_ID;
  const statusColor = Object.keys(STATUS_COLORS).find((key) => {
    const statusses = STATUS_COLORS[key];
    if (statusses.includes(data.status!)) {
      return key;
    }

    return false;
  });
  return (
    <LayoutTile
      key={data.id}
      hall={data.hall}
      fieldName={data.fieldName}
      to={data?.link}
      label={data.ticketName ? data.ticketName : data.name!}
      ticketName={data.ticketName}
      toLabel={translate(
        data.type === 'request' ? 'ecounter.requests.toLabel' : 'ecounter.notifications.toLabel',
      )}
      description={
        !isSportReservation ? dayjs(data.createdAt).format('DD MMMM YYYY, H.mm uur') : ''
      }
      from={data.from}
      until={data.until}
      target="_blank"
    >
      {isSportReservation && (
        <Typography classNames={['u-margin-bottom-xs']}>
          {translate('ecounter.reservation')}{' '}
          {dayjs(data.reservedAt).format('DD MMMM YYYY, H.mm uur')}
        </Typography>
      )}
      <Label className="u-margin-right-xs">
        {translate(
          data.type === 'request' ? 'ecounter.requests.label' : 'ecounter.notifications.label',
        )}
      </Label>
      <Label
        type={statusColor as LabelProps['type']}
        className={statusColor === undefined ? 'a-label--light' : ''}
      >
        {translate(`ecounter.status.${data.status}` as ITranslations)}
      </Label>
    </LayoutTile>
  );
};

export default Ticket;
